
import React from "react";
import PitchDeckModule from "@/modules/pitch-deck";

const PitchDeck = () => {
  return <PitchDeckModule />;
};

export default PitchDeck;
